import { render, staticRenderFns } from "./AgentManage.vue?vue&type=template&id=2dfc5651"
import script from "./AgentManage.vue?vue&type=script&lang=js"
export * from "./AgentManage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports